export function addToOrderAction (params) {
  return {
    type: 'ADD_TO_ORDER_REQUEST',
    payload: params
  }
}